const app_support_message = '<br /><br />If you continue to experience issues, please contact <b>App Support</b>'

export const ERROR_MESSAGES = {
    0: `The request could not be completed. Please try again. ${app_support_message}`,
    400: `There seems to be an issue with your input, such as invalid data, missing values, mismatched IDs, duplicate entries,
    or unsuccessful record processing. ${app_support_message}`,
    401: `Your credentials are invalid or your session has timed out. Please log in again. ${app_support_message}`,
    403: `You do not have the necessary permissions to perform this action. ${app_support_message}`,
    404: `The requested data could not be located. Please check your request and try again. ${app_support_message}`,
    500: `An unexpected error occurred on our end. Please try again later. ${app_support_message}`,
}